module.exports = __webpack_public_path__ + "static/media/banner_gr.dabb05b2.jpg";